export default __webpack_public_path__ + "static/media/aveneur.3e74543b.png";